import { Platform } from 'react-native';

let audioContext: AudioContext | null = null;

/**
 * Play a notification sound for new messages
 * Uses Web Audio API for web platform
 */
export const playNotificationSound = () => {
  if (Platform.OS !== 'web') {
    // For native platforms, we would use expo-av or react-native-sound
    // For now, only web is supported
    return;
  }

  try {
    // Create AudioContext lazily (must be created after user interaction)
    if (!audioContext) {
      audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    }

    // Resume context if suspended (browser autoplay policy)
    if (audioContext.state === 'suspended') {
      audioContext.resume();
    }

    // Create a simple notification sound using oscillators
    const now = audioContext.currentTime;
    
    // First tone
    const osc1 = audioContext.createOscillator();
    const gain1 = audioContext.createGain();
    osc1.connect(gain1);
    gain1.connect(audioContext.destination);
    osc1.frequency.value = 880; // A5 note
    osc1.type = 'sine';
    gain1.gain.setValueAtTime(0.3, now);
    gain1.gain.exponentialRampToValueAtTime(0.01, now + 0.15);
    osc1.start(now);
    osc1.stop(now + 0.15);

    // Second tone (slightly higher)
    const osc2 = audioContext.createOscillator();
    const gain2 = audioContext.createGain();
    osc2.connect(gain2);
    gain2.connect(audioContext.destination);
    osc2.frequency.value = 1100; // C#6 note
    osc2.type = 'sine';
    gain2.gain.setValueAtTime(0.3, now + 0.1);
    gain2.gain.exponentialRampToValueAtTime(0.01, now + 0.25);
    osc2.start(now + 0.1);
    osc2.stop(now + 0.25);

  } catch (error) {
    console.warn('Could not play notification sound:', error);
  }
};

/**
 * Initialize audio context (call after user interaction)
 */
export const initAudioContext = () => {
  if (Platform.OS !== 'web') return;
  
  try {
    if (!audioContext) {
      audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    }
  } catch (error) {
    console.warn('Could not initialize audio context:', error);
  }
};
